import {
  NewPersonCardAvailabilityContainer,
  NewPersonCardWrapper,
} from 'app/components/People/PeopleContent/PeopleList/NewPersonCard/styled';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import {
  slideToLeftAndRightCardAnimation,
  slideToLeftAndRightExtraCardAnimation,
} from 'styles/animations';

export const PeopleStepsOneSpotlightWrapper = styled(motion.div)`
  width: fit-content;
  position: relative;
  min-width: 288px;
  min-height: 455px;

  & ${NewPersonCardWrapper} {
    min-width: 288px;
    min-height: 455px;

    justify-content: center;
  }

  & [data-id='people-matched-detail-pills'] {
    display: none;
  }
`;

interface PeopleStepsOneSpotlightBackgroundCardProps {
  triggerNext?: boolean;
}

export const PeopleStepsOneSpotlightBackgroundCard = styled(
  motion.div
)<PeopleStepsOneSpotlightBackgroundCardProps>`
  position: absolute;
  top: 0;
  left: 0;

  & ${NewPersonCardAvailabilityContainer} {
    display: none;
  }
`;

export const PeopleStepsOneSpotlightBackgroundCardOne = styled(
  PeopleStepsOneSpotlightBackgroundCard
)`
  ${({ triggerNext }) => (triggerNext ? slideToLeftAndRightExtraCardAnimation : '')}
`;

export const PeopleStepsOneSpotlightBackgroundCardTwo = styled(
  PeopleStepsOneSpotlightBackgroundCard
)`
  ${({ triggerNext }) => (triggerNext ? slideToLeftAndRightCardAnimation : '')}
`;
